import React, { useEffect, useRef, useState } from "react";
import {
  GoogleMap,
  Marker,
  StandaloneSearchBox,
  useJsApiLoader,
} from "@react-google-maps/api";

const libraries = ["places"];


const containerStyle = {
  width: "100%",
  height: "420px",
};

const defaultCenter = {
  lat: 10.0735,
  lng: 78.7794,
};

export default function LocationPicker({
  open,
  onClose,
  onSelect,
  initialLocation,
}) {

  const { isLoaded } = useJsApiLoader({
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  libraries,
});
  const [selectedCity, setSelectedCity] = useState("");
  const searchRef = useRef(null);

  const [map, setMap] = useState(null);

  const [marker, setMarker] = useState(
    initialLocation || defaultCenter
  );

  const [address, setAddress] = useState("");

  useEffect(() => {
    if (initialLocation) {
      setMarker(initialLocation);
    }
  }, [initialLocation]);

  if (!open) return null;

 const reverseGeocode = (lat, lng) => {
  const geocoder = new window.google.maps.Geocoder();

  geocoder.geocode(
    { location: { lat, lng } },
    (results, status) => {
      if (status === "OK" && results[0]) {
        setAddress(results[0].formatted_address);

        const city =
          results[0].address_components.find((c) =>
            c.types.includes("locality")
          ) ||
          results[0].address_components.find((c) =>
            c.types.includes("administrative_area_level_2")
          );

        setSelectedCity(city?.long_name || "");
      }
    }
  );
};
  const onMapClick = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    setMarker({ lat, lng });

    reverseGeocode(lat, lng);
  };

  const useCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      setMarker({ lat, lng });

      if (map) {
        map.panTo({ lat, lng });
      }

      reverseGeocode(lat, lng);
    });
  };

  const searchPlace = () => {
    const places = searchRef.current.getPlaces();

    if (!places || places.length === 0) return;

    const place = places[0];

    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    setMarker({ lat, lng });

    map.panTo({ lat, lng });

    setAddress(place.formatted_address);

    const city =
  place.address_components?.find((c) =>
    c.types.includes("locality")
  ) ||
  place.address_components?.find((c) =>
    c.types.includes("administrative_area_level_2")
  );

setSelectedCity(city?.long_name || "");
  };

  return (
    <div className="vendor-modal-overlay">

      <div className="location-picker-modal">

        <div className="location-picker-header">

          <h3>Select Business Location</h3>

          <button onClick={onClose}>
            ✕
          </button>

        </div>

        <button
          className="location-current-btn"
          onClick={useCurrentLocation}
        >
          📍 Use Current Location
        </button>

        {isLoaded && (
          <StandaloneSearchBox
            onLoad={(ref) => (searchRef.current = ref)}
            onPlacesChanged={searchPlace}
          >
            <input
              className="location-search"
              placeholder="Search business address..."
            />
          </StandaloneSearchBox>
        )}

        {isLoaded && (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={marker}
            zoom={15}
            onLoad={setMap}
            onClick={onMapClick}
          >
            <Marker
              position={marker}
              draggable
              onDragEnd={onMapClick}
            />
          </GoogleMap>
        )}

        <textarea
          value={address}
          readOnly
          rows={3}
        />

        <div className="location-coordinates">

          <span>
            Latitude : {marker.lat}
          </span>

          <span>
            Longitude : {marker.lng}
          </span>

        </div>

        <button
          className="admin-primary-btn"
          onClick={() => {
            onSelect({
  address,
  city: selectedCity,
  latitude: marker.lat,
  longitude: marker.lng,
});
            onClose();
          }}
        >
          Confirm Location
        </button>

      </div>

    </div>
  );
}